import React, { FC, useMemo } from 'react';
import styles from './Slider.module.less';
import clsx from 'clsx';

interface SliderProps {
  percent?: number;
  type?: 'inprogress' | 'in-pipeline' | 'completed';
}

const Slider: FC<SliderProps> = ({ type = 'inprogress', percent = 0 }) => {
  const handler = useMemo(() => {
    if (type === 'in-pipeline') {
      return `/images/upcoming/pipeline_handler.svg`;
    }
    if (type === 'completed') {
      return `/images/upcoming/completed_handler.svg`;
    }

    return `/images/upcoming/inprogress_handler.svg`;
  }, []);

  return (
    <div className={styles.progress}>
      <div className={clsx(styles.bar, styles[type])} style={{ width: `${percent}%` }}>
        <div className={styles.handler}>
          {type === 'inprogress' && (
            <span>
              {percent}
              <span className="medium text-10">&nbsp;%</span>
            </span>
          )}
          <img src={handler} alt="handler" />
        </div>
      </div>
    </div>
  );
};

export default Slider;
